import { useQuery } from "@tanstack/react-query";

const API_URL = import.meta.env.VITE_API_URL || 'https://soundope.com';

/**
 * Hook to get a user's current leaderboard position (1-10)
 * Returns null if user is not in top 10 OR if user is anonymous
 */
export function useLeaderboardPosition(userId) {
  return useQuery({
    queryKey: ["leaderboard-position", userId],
    queryFn: async () => {
      if (!userId) return null;

      // Fetch tracks ordered by praise_count to determine position
      const response = await fetch(`${API_URL}/api/tracks?is_active=true&order_by=praise_count&order=desc&limit=10`, {
        credentials: 'include',
      });
      
      if (!response.ok) return null;
      
      const tracks = await response.json();
      if (!tracks || tracks.length === 0) return null;

      // Find the user's highest ranked track
      for (let i = 0; i < tracks.length; i++) {
        if (tracks[i].artist_id === userId) {
          return i + 1; // Position (1-based)
        }
      }

      return null; // Not in top 10
    },
    enabled: !!userId,
    staleTime: 30000,
    gcTime: 60000,
  });
}

